<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/knBRNq/tc-custom/9781473816749.jpg?1705778905853" alt="This image is the cover for the book Night Action"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Night Action
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A highly decorated Royal Navy officer recounts his experiences at the command of a motor torpedo boat in the North Sea during WWII.</b><br/>  <br/> In 1942-43, Captain Peter Dickens commanded the 21st MTB Flotilla, mainly in the North Sea and the English Channel. In <i>Night Action</i>, he vividly recounts his experiences performing daring missions amid storms of gunfire, usually under the cover of darkness. Dickens and his crew managed to closely engage enemy convoys and escorts in high-speed attacks and wreak havoc among the German supply lines.<br/>  <br/> Like the sailors who fought Nazi U-boats in the battle of the Atlantic, Dickens and his comrades were experiencing a new kind of warfare and had to develop techniques and tactics as they went along; their kind of action called for great courage, spilt-second timing and complete understanding between captain and crew.<br/>  <br/> For his bravery and heroism, Dickens was awarded The Distinguished Service Order, a Distinguished Service Cross, and The Most Excellent Order of the British Empire. In <i>Night Action</i>, he offers a frank depiction of live aboard the 21st MTB Flotilla, combining comradery and humor with the true horror of war</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter Dickens
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Seaforth Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7a5664d7